import styled from "styled-components";

import { colorsPalettes, mixins } from "@similarweb/styles";
import { FlexRow } from "@similarweb/ui-components";
import { Flex } from "@similarweb/ui-components/foundations";

export const StyledSignalsPromoBannerWrapper = styled.div`
    box-sizing: border-box;
    display: flex;
    align-items: center;
    width: 100%;
    margin-top: 16px;
    padding: 20px 24px 16px 24px;
    border-radius: 6px;
    background: ${colorsPalettes.sky[100]};
`;

export const StyledSignalsPromoBannerImage = styled.img`
    width: 24px;
    height: 24px;
`;

export const StyledSignalsPromoBannerContent = styled(FlexRow)`
    margin-left: 19px;
    width: 100%;
    justify-content: space-between;
`;

export const StyledSignalsPromoBannerTitle = styled.p`
    ${mixins.setFontVariant("subtitle1", colorsPalettes.indigo[300])};
    margin: 0 0 4px;
`;

export const StyledSignalsPromoBannerSubtitle = styled.p`
    ${mixins.setFontVariant("body2", colorsPalettes.indigo[300])};
    margin: 0;
`;

export const StyledSignalsPromoBannerButton = styled(Flex)`
    align-items: center;
`;
